<template>
    <div class="dashboard">
        <div class="dashboard__box">
            <v-calendar v-bind:attributes="vCalendarAttributes" v-on:update:page="handleVCalendarUpdate">
            </v-calendar>

            <task-list v-bind:showActions="false">
            </task-list>

            <div class="dashboard__box__element has-margin-b30">
                <router-link class="btn is-primary"
                             v-bind:to="{ name: 'calendar.index' }"
                >
                    {{ __('Edit') }}
                </router-link>
            </div>
        </div>
        <div class="dashboard__box">
            <div class="dashboard__box__label">{{ __('Recent Startdesks') }}</div>
            <div class="startdesk" v-for="startdesk in startdesks">
                <a class="startdesk__name"
                   v-on:click.prevent="handleViewStartdesk(startdesk)"
                >
                    {{ startdesk.name }}
                </a>

                <a class="startdesk__screenshot"
                   v-bind:style="startdeskBackgroundProperty(startdesk)"
                   v-on:click.prevent="handleViewStartdesk(startdesk)"
                >
                </a>
            </div>
        </div>
        <div>
            <div class="dashboard__box has-margin-b15 has-padding" v-if="recommendedForYou != ''" v-html="recommendedForYou"></div>
            <div class="dashboard__box has-blue-background " v-html="weather"></div>
        </div>
    </div>
</template>

<script>
    import { Calendar } from 'dayspan';
    import { eventBus } from '../eventBus.js';
    import startdesk from './Startdesk.vue';
    import taskList from './TaskList.vue';

    export default {
        components: {
            startdesk,
            taskList
        },
        data: function () {
            return {
                calendar: Calendar.months(),
                currentCity: 'Budapest',
                currentLatitude: null,
                currentLongitude: null,
                recommendedForYou: '',
                startdesks: null,
                todayEvents: [],
                tomorrowEvents: [],
                vCalendarCurrentMonth: null,
                vCalendarKeys: [],
                vCalendarAttributes: [
                    {
                        highlight: {
                            backgroundColor: '#5e8dff'
                        },
                        contentStyle: {
                            color: 'white'
                        },
                        dates: [new Date(2019, 2, 1)]
                    }
                ],
                weather: '<a class="weatherwidget-io" href="https://forecast7.com/en/47d5019d04/budapest/" data-label_1="BUDAPEST" data-label_2="WEATHER" data-theme="original" data-basecolor="#5e8dff" data-highcolor="#febebe" data-lowcolor="#c1dafe" data-cloudcolor="#d2d2d2" data-raincolor="#c1daff" >BUDAPEST WEATHER</a>'
            }
        },
        methods: {
            getCurrentLocation: function() {
                if (!navigator.geolocation) {
                    console.warn("Geolocation is not supported by your browser");
                    return;
                }
                var options = {
                    timeout:60000
                };
                navigator.geolocation.getCurrentPosition(function(position) {
                    this.currentLatitude = parseFloat(position.coords.latitude).toFixed(2);
                    this.currentLongitude = parseFloat(position.coords.longitude).toFixed(2);

                    this.getWeather();
                }.bind(this), function(err) {
                    console.warn('ERROR(${err.code}): ${err.message}');
                    console.warn("Unable to retrieve your location");
                }, options);
            },
            getEvents: function () {
                eventBus.$emit('show-loader');

                this.$http.get(this.apiUrl + '/calendar/events', {
                    params : {
                        filters: {
                            'user_id': this.user.id
                        },
                        page: 1,
                        perPage: 0
                    }
                }).then(function (response) {
                    let events = response.body.original.data;

                    events.forEach(function(event) {
                        this.calendar.addEvent({
                            'data': {
                                'color': event.color,
                                'description': event.description,
                                'icon': event.icon,
                                'id': event.id,
                                'location': event.location,
                                'title': event.title
                            },
                            'schedule': JSON.parse(event.schedule)
                        })
                    }.bind(this));

                    // get today's and tomorrow's events
                    this.todayEvents = this.calendar.getDay(true).events;

                    let today = new Date();
                    let tomorrow = new Date();
                    tomorrow.setDate(today.getDate()+1);
                    this.tomorrowEvents = this.calendar.getDay(tomorrow.getTime()).events;

                    // add events to v-calendar
                    let date = null;
                    for (let i=0; i < 31; i++) {
                        date = new Date(today.getFullYear(), today.getMonth(), i);
                        if (this.calendar.getDay(date.getTime()).events.length > 0) {
                            this.vCalendarAttributes[0].dates.push(date)
                        }
                    }
                    this.vCalendarKeys.push(today.getFullYear() + '.' + (today.getMonth() + 1));
                    this.vCalendarCurrentMonth = today.getMonth() + 1;


                    eventBus.$emit('hide-loader');
                }.bind(this), function (response) {
                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There was an error retrieving data from the server.')
                    );

                    eventBus.$emit('hide-loader');
                });
            },
            getSettings: function () {
                eventBus.$emit('show-loader');

                this.$http.get(this.apiUrl + '/settings').then(function (response) {
                    const settings = response.body.original;

                    settings.forEach(function(setting, key) {
                        if (setting.key == 'recommendedForYou') {

                        }
                        this.recommendedForYou = setting.value;
                    }.bind(this));

                    eventBus.$emit('hide-loader');

                }, function (response) {
                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There was an error retrieving data from the server.')
                    );

                    eventBus.$emit('hide-loader');
                });
            },
            getStartdesks: function () {
                this.$http.get(this.apiUrl + '/startdesks', {
                    params : {
                        filters: {
                            is_visible_to_user: 1
                        },
                        page: 1,
                        perPage: 3,
                        sortBy: 'created_at',
                        sortOrder: 'desc'
                    }
                }).then(function (response) {
                    this.startdesks = response.body.original.data;

                    eventBus.$emit('hide-loader');
                }.bind(this), function (response) {
                    eventBus.$emit(
                            'show-alert',
                            'error',
                            this.__('There was an error retrieving data from the server.')
                    );

                    eventBus.$emit('hide-loader');
                });
            },
            handleVCalendarUpdate: function (page) {
                if (this.vCalendarCurrentMonth > page.month) {
                    this.calendar.prev();
                }
                else {
                    this.calendar.next();
                }

                this.vCalendarCurrentMonth = page.month;

                // add events to v-calendar
                if (!this.vCalendarKeys.includes(page.key)) {

                    let date = null;
                    for (let i=0; i < 31; i++) {
                        date = new Date(page.year, page.month - 1, i);
                        let day = this.calendar.getDay(date.getTime());
                        if (day && day.events.length > 0) {
                            this.vCalendarAttributes[0].dates.push(date)
                        }
                    }

                    this.vCalendarKeys.push(page.key);
                }
            },
            handleViewStartdesk: function(startdesk) {
                this.viewStartdesk(startdesk);

                this.$router.push({
                    name: 'startdesks.view',
                    params: { startdesk: startdesk.slug, u: startdesk.is_user_startdesk }
                });


            },
            initWeatherWidget: function () {
                let weatherScript = document.getElementById('weatherwidget-io-js');
                if (weatherScript) {
                    weatherScript.remove();
                }

                ! function(d, s, id) {
                    var js, fjs = d.getElementsByTagName(s)[0];
                    if (!d.getElementById(id)) {
                        js = d.createElement(s);
                        js.id = id;
                        js.src = 'https://weatherwidget.io/js/widget.min.js';
                        fjs.parentNode.insertBefore(js, fjs);
                    }
                }(document, 'script', 'weatherwidget-io-js');
            },
            startdeskBackgroundProperty: function (startdesk) {
                return 'background-image: url(' + this.appUrl + '/media/startdesks/' + startdesk.share_image + '?v=' + startdesk.updated_at.replace(' ', '-').replace(/:/g, '-') + ')';
            }
        },
        mounted: function () {
            this.getEvents();
            this.getStartdesks();
            this.initWeatherWidget();
            this.getSettings();
            //this.getCurrentLocation();
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/Dashboard.vue